import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { useSidebar } from "./index";
import { cn } from "../../lib/utils";

const SidebarListContent = ({ children, onScroll, className, scrollbarProps }) => {
	const { side } = useSidebar();

	return (
		<div className={cn("flex-1 flex flex-col max-h-full overflow-auto", className)}>
			<OverlayScrollbarsComponent
				className="overflow-auto max-h-full h-full flex"
				{...scrollbarProps}
				events={{
					scroll: (e) => {
						const { content } = e.elements();
						onScroll?.({ target: content });
					},
				}}
			>
				<div
					className={cn(
						"pt-6 pb-11 w-full relative grid gap-5 h-full items-start content-start",
						side === "left" && "pl-9 pr-7",
						side === "right" && "pl-7 pr-9"
					)}
				>
					{children}
				</div>
			</OverlayScrollbarsComponent>
		</div>
	);
};

export default SidebarListContent;
